@if (machineryList().length > 0) {
  <div class="flex items-center gap-3 px-4 pt-0 pb-3 flex-wrap pl-1">
    <span class="text-sm font-medium shrink-0">Macchinario attivo:</span>
    <mat-chip-listbox
      aria-label="Seleziona il macchinario"
      [disabled]="machineryList().length === 1"
      (change)="onSelectionChange($event)"
    >
      @for (machinery of machineryList(); track machinery.id) {
        <mat-chip-option
          [value]="machinery"
          [selected]="machinery.id === selectedId()"
        >
          {{ machinery.name }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
}
